import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

//  http://wiki.xunlei.cn/pages/viewpage.action?pageId=120400519
export const exp_record = createAsyncThunk(
  '/live/vip/exp_record',
  async (
    arg: {
      time?: string
      limit: number
      offset: number
    },
    store: any
  ) => {
    const resp = await http.post<HiyaRes<InitialStateType['exp']>>(
      '/live/vip/exp_record',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=120400862
export const level_record = createAsyncThunk(
  '/live/vip/level_record',
  async (
    arg: {
      time: string
      limit: number
      offset: number
    },
    store: any
  ) => {
    const resp = await http.post<HiyaRes<InitialStateType['level']>>(
      '/live/vip/level_record',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
export enum StateEnum {
  locked = 1,
  LevelLimit = 2,
  Frozen = 3,
  Keeping = 4,
  TopKeeping = 5,
  Upgrading = 6,
  TopUpgrading = 7,
}
export interface InitialStateType {
  exp: {
    // 当前经验
    exp?: number
    // 状态
    state?: StateEnum
    // 当前vip等级
    cur_level?: number
    // 当前等级所需经验值
    cur_level_exp?: number
    cur_level_type?: string
    // 下一vip等级
    next_level?: number
    // 下一级所需经验值
    next_level_exp?: number
    next_level_type?: string
    time?: string
    offset?: number
    record_list?: Array<{
      year: number
      month: number
      total_gain: number
      records: Array<{
        desc: string
        time: string
        count: number
        total_exp: string
      }>
    }>
    more?: boolean
  }
  level: {
    time?: string
    offset?: number
    record_list?: Array<{
      year: number
      month: number
      total_gain: number
      records: Array<{
        icon: string
        desc: string
        time: string
        level: number
        state: 1 | 2
      }>
    }>
    more?: boolean
  }
}

const initialState: InitialStateType = {
  exp: {},
  level: {},
}

const mergeList = (data: {
  old: Array<{
    year: number
    month: number
    records: any[]
  }>
  add: Array<{
    year: number
    month: number
    records: any[]
  }>
  offset: number
}) => {
  if (data.offset === 0) {
    return data.add
  }
  const temp = data.old
  data.add.forEach((v) => {
    const has = temp.find((i) => {
      return i.year === v.year && i.month === v.month
    })
    if (has) {
      has.records = has.records.concat(v.records)
    } else {
      temp.push(v)
    }
  })
  return temp
}

export const VipRecordSlice = createSlice({
  name: 'Animal_Elephant',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(exp_record.fulfilled, (state, action) => {
      Object.assign(state.exp, {
        ...action.payload,
        record_list: mergeList({
          old: state.exp.record_list,
          add: action.payload.record_list,
          offset: action.meta.arg.offset,
        }),
      })
    })
    builder.addCase(level_record.fulfilled, (state, action) => {
      Object.assign(state.level, {
        ...action.payload,
        record_list: mergeList({
          old: state.level.record_list,
          add: action.payload.record_list,
          offset: action.meta.arg.offset,
        }),
      })
    })
  },
})
export default VipRecordSlice.reducer
export const VipRecordActions = VipRecordSlice.actions

export const useVipRecordState = () => {
  const data = useSelector((state) => {
    return state.Animal_Elephant
  })
  return data
}
